module.exports = __webpack_public_path__ + "img/thailandflag.b32f1769.svg";